import React from 'react';
import {withRouteData, Head} from 'react-static';
import Markdown from '../../lib/Markdown';
import styles from './style.scss';

export default withRouteData(function Pricing({page}) {
  return (
    <React.Fragment>
      <Head>
        <title>{page.title}</title>
      </Head>
      <Markdown source={page.content} className={styles.content} />
      <div className={styles.packages}>
        {page.packages.map(({name, price, body}, index) => (
          <div key={index} className={styles.package}>
            <div className={styles.packageHeader}>
              <h2 className={styles.packageName}>{name}</h2>
              <h3 className={styles.packagePrice}>{price}</h3>
            </div>
            <Markdown source={body} className={styles.packageBody} />
          </div>
        ))}
      </div>
    </React.Fragment>
  );
});

/*

Some good sample pages:

  * https://www.photographerpete.com.au/pricing-wedding-photography-packages/
  * https://kitanobophotography.com.au/pricing/
  * http://jasoncheckla.com/pricing-table/

*/
